module.exports = __webpack_public_path__ + "img/route_adv_2.c029ba24.png";